import ReactDOM from 'react-dom';
import CollectionManager from '@app/utilities/CollectionManager';
import { defaultServiceContext } from '@app/contexts';
import { RootLayout } from './pages/layout';
import AppManager from './utilities/AppManager';
import '@app/router/hash-change';
import '@app/styles/native.scss';
import '@app/styles/override.scss';
import '@app/styles/ui-library-settings.scss';

// Define a global access to for debugging and old code (new code should use React context).
window.serviceContext = defaultServiceContext;

(function initTimestamp() {
  const xmlhttp = new XMLHttpRequest();
  xmlhttp.open('HEAD', 'https://health.us-east-1.amazonaws.com/', true);
  xmlhttp.onload = function () {
    if (xmlhttp.readyState === 4) {
      let serverDateStr = xmlhttp.getResponseHeader('Date')!;
      let serverTimestamp = new Date(serverDateStr).getTime();
      let nowTimeStamp = Date.now();
      let timeOffset = serverTimestamp - nowTimeStamp;
      window.frontPageTimeStamp = Date.now() + timeOffset;
    }
  };
  xmlhttp.send(null);
})();

// Collection initialization.
window.colm = new CollectionManager();
window.colm.init();

// Wait for everything to be set up.
setTimeout(() => {
  const { href, pathname } = window.location;
  if (!pathname.startsWith('/app')) {
    return;
  }

  const branchId = new URL(href).searchParams.get('g');
  if (!branchId) {
    window.location.href = `/${location.search}`;
    throw new Error();
  }
  window.apm = new AppManager(branchId);
  window.apm.init();
}, 100);

/** jQuery extensions. */
$.fn.extend({
  animateCss: function(this: any, animationName: string) {
    this.addClass('animated ' + animationName).one(
      'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
      function(this: any) {
        $(this).removeClass('animated ' + animationName);
      }
    );
    return this;
  },
  getCursorPosition: function(this: any) {
    if (this.length === 0) {
      return -1;
    }
    return ($(this) as any).getSelectionStart();
  },
  getSelectionStart: function(this: any) {
    if (this.length === 0) {
      return -1;
    }
    let input = this[0];
    let pos = input.value.length;

    if (input.createTextRange) {
      let r = (document as any).selection.createRange().duplicate();
      r.moveEnd('character', input.value.length);
      if (r.text === '') {
        pos = input.value.length;
      }
      pos = input.value.lastIndexOf(r.text);
    } else if (typeof input.selectionStart !== 'undefined') {
      pos = input.selectionStart;
    }
    return pos;
  }
});

const { lokiService } = defaultServiceContext;
lokiService.init();

ReactDOM.render(<RootLayout />, document.getElementById('root'));
